import React, { useEffect, useState } from 'react';
import { ChevronLeft, Plus, Check } from 'lucide-react';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';

// Cabeçalho igual ao AppBarLayout de fragment_routine.xml — "Acordar" é o
// próprio texto de exemplo do layout (routineTitle). As tarefas abaixo são
// subrotinas ilustrativas: o app não tem uma lista fixa, cada uma é criada
// pelo usuário em CreateSubRoutine — só o formato (ícone circular + rótulo +
// horário, campo `hora` de SubRoutine.kt e o "10:00" de exemplo em
// item_subroutine.xml) é real.
const ROUTINE_TITLE = 'Acordar';
const TASKS = [
  { emoji: '⏰', label: 'Levantar da cama', time: '06:30' },
  { emoji: '🪥', label: 'Escovar os dentes', time: '06:40' },
  { emoji: '👕', label: 'Vestir a roupa', time: '06:50' },
  { emoji: '🎒', label: 'Arrumar a mochila', time: '07:00' },
];

const STEP_MS = 1100;
const HOLD_MS = 1900;

/** Simula o check-off de uma rotina real: cada subrotina ganha o selo de concluída, uma de cada vez, e reinicia. */
export function RoutineLiveDemo() {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [doneCount, setDoneCount] = useState(0);

  useEffect(() => {
    if (prefersReducedMotion) return;
    const delay = doneCount >= TASKS.length ? HOLD_MS : STEP_MS;
    const timer = setTimeout(() => {
      setDoneCount((c) => (c >= TASKS.length ? 0 : c + 1));
    }, delay);
    return () => clearTimeout(timer);
  }, [doneCount, prefersReducedMotion]);

  const shown = prefersReducedMotion ? 2 : doneCount;

  return (
    <div className="rounded-2xl bg-card shadow-lg overflow-hidden" aria-hidden="true">
      {/* Cabeçalho da rotina */}
      <div className="flex items-center gap-2 px-4 py-3.5 bg-primary/10 dark:bg-primary/15">
        <ChevronLeft className="w-4 h-4 text-primary-ink dark:text-primary-tint flex-shrink-0" />
        <span className="flex-1 text-center font-bold text-foreground">{ROUTINE_TITLE}</span>
        <Plus className="w-4 h-4 text-primary-ink dark:text-primary-tint flex-shrink-0" />
      </div>

      {/* Subrotinas com selo de concluída */}
      <div className="p-3.5 space-y-2">
        {TASKS.map((task, i) => {
          const isDone = i < shown;
          return (
            <div
              key={task.label}
              className={`flex items-center gap-3 rounded-xl px-3 py-2.5 transition-colors duration-500 ${
                isDone ? 'bg-primary/10 dark:bg-primary/15' : 'bg-muted/50'
              }`}
            >
              <span className="relative w-9 h-9 rounded-full bg-background flex items-center justify-center text-base flex-shrink-0 shadow-sm">
                {task.emoji}
                {isDone && (
                  <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-primary flex items-center justify-center">
                    <Check className="w-2.5 h-2.5 text-white" />
                  </span>
                )}
              </span>
              <span
                className={`flex-1 text-sm font-medium transition-colors duration-500 ${
                  isDone ? 'text-foreground' : 'text-muted-foreground'
                }`}
              >
                {task.label}
              </span>
              <span
                className={`text-xs font-bold tabular-nums transition-colors duration-500 ${
                  isDone ? 'text-primary-ink dark:text-primary-tint' : 'text-muted-foreground'
                }`}
              >
                {task.time}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
